<!-- 
	标题组件 
	1、标题模板：4种
	2、显示样式：居左显示  居中显示  居右显示
	3、背景色、背景图片
	4、导航文字
	5、主标题：标题内容、文字大小、文字颜色
	6、副标题：标题内容、文字大小、文字颜色
-->
<template>
	<view class="component-wrapper" :style="wrapperStyle">
		<view class="more-wrapper" v-if="data.decorateLinkId">
			<view class="f_r_c_e">
				{{moreText ? moreText : '更多'}}<up-icon name="arrow-right"></up-icon>
			</view>
		</view>
		<view v-if="data.titleType == 1 || data.titleType == 2 || data.titleType == 3" :style="firstTitleStyle">
			<image v-if="data.iconImg && (data.titleType == 2 || data.titleType == 3)" :src="data.iconImg" style="width: 12px; height: 12px;margin-right: 5px;" mode="aspectFill"></image>
			<image v-if="!data.iconImg && (data.titleType == 2 || data.titleType == 3)" :src="defaultImage" style="width: 12px; height: 12px;margin-right: 5px;" mode="aspectFill"></image>
			<view v-if="data.mainTitleName" :style="titleStyle">{{ data.mainTitleName }}</view>
			<image v-if="data.iconImg && data.titleType == 3" :src="data.iconImg" style="width: 12px; height: 12px;margin-left: 5px;" mode="aspectFill"></image>
			<image v-if="!data.iconImg && data.titleType == 3" :src="defaultImage" style="width: 12px; height: 12px;margin-left: 5px;" mode="aspectFill"></image>
		</view>
		<view v-if="(data.titleType == 1 || data.titleType == 2 || data.titleType == 3) && data.subTitleName" :style="secondTitleStyle">{{ data.subTitleName }}</view>
		<view v-if="data.titleType == 4" :style="titlePanelStyle">
			<view v-if="data.mainTitleName" :style="titleStyle">{{ data.mainTitleName }}</view>
			<view class="line"></view>
			<view v-if="data.subTitleName" :style="secondTitleStyle">{{ data.subTitleName }}</view>
		</view>
	</view>
</template>
<!--
"decorateTitleBo": {
	"id": "49d3345d740711f0a3479c5c8ebcfe65",
	"companyId": "1",
	"shopId": "1",
	"decorateId": "ad0507d26f9f11f0a3479c5c8ebcfe65",
	"decorateModuleId": "49d22281740711f0a3479c5c8ebcfe65",
	"titleType": 3,
	"iconImg": "",
	"displayPosition": "left",
	"moreText": "更多",
	"mainTitleName": "为您推荐",
	"mainTitleColor": "#999999",
	"subTitleName": "",
	"subTitleColor": "#999999",
	"createTime": "2025-08-08 11:25:10",
	"mainTitleFontSize": 14,
	"subTitleFontSize": 12
}
-->

<script setup>
	import {fnImgRequestPath} from "@/utils/utils";
	import defaultImage from "@/static/images/tit_one_icon.png";
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					/**
					 * 标题模板 1 无图标 2 左图标 3左右图标 4主、副标题分割
					 */
					"titleType":  {
						type: Number,
						default: 1
					},
					/**
					 * 显示样式：居左显示  居中显示  居右显示
					 */
					"displayPosition":  {
						type: String,
						default: 'left'
					},
					/**
					 * 导航文字
					 */
					"moreText":  {
						type: String,
						default: '更多'
					},
					/**
					 * 主标题名称
					 */
					"mainTitleName":  {
						type: String,
						default: '为您推荐'
					},
					/**
					 * 主标题颜色
					 */
					"mainTitleColor":  {
						type: String,
						default: '#999999'
					},
					/**
					 * 主标题大小
					 */
					"mainTitleFontSize":  {
						type: Number,
						default: 14
					},
					/**
					 * 副标题名称
					 */
					"subTitleName":  {
						type: String,
						default: '为您推荐'
					},
					/**
					 * 副标题颜色
					 */
					"subTitleColor":  {
						type: String,
						default: '#999999'
					},
					/**
					 * 副标题大小
					 */
					"subTitleFontSize":  {
						type: Number,
						default: 12
					},
					/**
					 * 标题图标
					 */
					"iconImg": {
						type: String,
						default: ''
					},
					/**
					 * 背景颜色
					 */
					"backgroundColor":  {
						type: String,
						default: "#ffffff"
					},
					/**
					 * 背景图片
					 */
					"backgroundUrl":  {
						type: String,
						default: ""
					},
					/**
					 * 链接记录表id
					 */
					"decorateLinkId":  {
						type: String,
						default: ""
					},
					/**
					 * 链接记录名称
					 */
					"decorateLinkName":  {
						type: String,
						default: ""
					}
				}
			}
		}
	})
	
	/**
	 * 组件样式
	 */
	const wrapperStyle = computed(() => {
		const {
			displayPosition,
			backgroundColor,
			backgroundUrl
		} = props.data;
		/**
		 * 显示样式：1居左显示  2居中显示  3居右显示
		 */
		if(displayPosition === 'center'){
			return `
				width: 100%;
				text-align: center;
				background-color: ${backgroundColor};
				background-image: url(${backgroundUrl ? getImageUrl(backgroundUrl) : ''});
				background-repeat: repeat;
				background-size: 100% 100%;
				bakcground-position: center;
			`;
		}else if(displayPosition === 'right'){
			return `
				width: 100%;
				text-align: right;
				background-color: ${backgroundColor};
				background-image: url(${backgroundUrl ? getImageUrl(backgroundUrl) : ''});
				background-repeat: repeat;
				background-size: 100% 100%;
				bakcground-position: center;
			`;
		}else{
			// 为您推荐上下距离和字体加粗
			return `
				width: 100%;
				text-align: left;
				background-color: ${backgroundColor};
				background-image: url(${backgroundUrl ? getImageUrl(backgroundUrl) : ''});
				background-repeat: repeat;
				background-size: 100% 100%;
				bakcground-position: center;
				padding: 20rpx;
				font-weight: bold;
			`;
		}
	})
	
	
	/**
	 * 标题样式
	 */
	const titleStyle = computed(() => {
		const {
			mainTitleColor,
			mainTitleFontSize
		} = props.data;
		return `
			font-size: ${mainTitleFontSize ? mainTitleFontSize : 16}px;
			color: ${mainTitleColor};
		`;
	})
	
	
	/**
	 * 主标题样式
	 */
	const firstTitleStyle = computed(() => {
		const {
			displayPosition
		} = props.data;
		/**
		 * 显示样式：1居左显示  2居中显示  3居右显示
		 */
		if(displayPosition == 'center'){
			return `
				display: -webkit-flex;
				display: flex;
				-webkit-flex-direction:row;
				flex-direction: row;
				-webkit-align-items:center;
				align-items: center;
				-webkit-justify-content: center;
				justify-content: center;
			`;
		}else if(displayPosition == 'right'){
			return `
				display: -webkit-flex;
				display: flex;
				-webkit-flex-direction:row;
				flex-direction: row;
				-webkit-align-items:center;
				align-items: center;
				-webkit-justify-content: flex-end;
				justify-content: flex-end;
			`;
		}else{
			return `
				display: -webkit-flex;
				display: flex;
				-webkit-flex-direction:row;
				flex-direction: row;
				-webkit-align-items:center;
				align-items: center;
				-webkit-justify-content: flex-start;
				justify-content: flex-start;
			`;
		}
	})
	
	/**
	 * 副标题样式
	 */
	const secondTitleStyle = computed(() => {
		const {
			subTitleColor,
			subTitleFontSize
		} = props.data;
		return `
			font-size: ${subTitleFontSize ? subTitleFontSize : 12}px;
			color: ${subTitleColor};
		`;
	})
	
	/**
	 * 样式4 title样式
	 */
	const titlePanelStyle = computed(() => {
		const {
			displayPosition
		} = props.data;
		/**
		 * 显示样式：1居左显示  2居中显示  3居右显示
		 */
		if(displayPosition == 'center'){
			return `
				display: -webkit-flex;
				display: flex;
				-webkit-flex-direction:row;
				flex-direction: row;
				-webkit-align-items:flex-end;
				align-items: flex-end;
				-webkit-justify-content: center;
				justify-content: center;
			`;
		}else if(displayPosition == 'right'){
			return `
				display: -webkit-flex;
				display: flex;
				-webkit-flex-direction:row;
				flex-direction: row;
				-webkit-align-items:flex-end;
				align-items: flex-end;
				-webkit-justify-content: flex-end;
				justify-content: flex-end;
			`;
		}else{
			return `
				display: -webkit-flex;
				display: flex;
				-webkit-flex-direction:row;
				flex-direction: row;
				-webkit-align-items:flex-end;
				align-items: flex-end;
				-webkit-justify-content: flex-start;
				justify-content: flex-start;
			`;
		}
	})
	
	/**
	 * 标题
	 */
	const title = computed(() => {
		return props.data.title || '标题';
	})
	
	/**
	 * 标题
	 */
	const secondTitle = computed(() => {
		return props.data.secondTitle || '副标题';
	})
	
	/**
	 * 获取图片地址
	 */
	function getImageUrl(imgUrl){
		return fnImgRequestPath(imgUrl);
	}
</script>

<style lang="less" scoped>
	
	.component-wrapper {
		display: block;
		max-width: 100%;
		text-align: center;
		overflow: hidden;
		text-decoration: none;
		padding-left: 10px;
		padding-right: 10px;
		padding-top: 5px;
		padding-bottom: 5px;
	}
	
	.more-wrapper {
		position: absolute;
		right: 5px;
		color: #000000;
		margin-top: 2px;
	}
	
	.line {
		border-left: 2px solid #ccc;
		height: 15px; /* 控制竖线高度 */
		margin: 0px 8px 0px 8px; /* 控制间距 */
	}
</style>
